import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/Common/SectionTitle';

// Images
import heroImg from '../../assets/img/community-hero-new.jpg';
import gallery1 from '../../assets/img/community-gallery-small-1-new.jpg';
import gallery2 from '../../assets/img/community-gallery-large-new.jpg';
import gallery3 from '../../assets/img/community-gallery-small-2-new.jpg';

import AOS from 'aos';

const CommunityMain = () => {
    React.useEffect(() => {
        AOS.init();
    }, []);

    return (
        <div className="rs-community">
            <style>
                {`
                .gallery-item {
                    transition: transform 0.4s ease, box-shadow 0.4s ease;
                }
                .gallery-item:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 30px rgba(0,0,0,0.15);
                }
                .gallery-item img {
                    transition: transform 0.6s ease;
                }
                .gallery-item:hover img {
                    transform: scale(1.05);
                }
                .services-item {
                    transition: all 0.3s ease;
                }
                .services-item:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 25px rgba(0,0,0,0.08);
                }
                `}
            </style>
            {/* 1. Hero / Intro Section */}
            <div className="rs-about style2 pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 md-mb-50">
                            <div className="sec-title" data-aos="fade-up" data-aos-duration="1200">
                                <span className="sub-title primary">Join the Movement</span>
                                <h2 className="title mb-20">
                                    A Community of <br />
                                    <span style={{ color: '#ffc107' }}>Innovators & Creators</span>
                                </h2>
                                <p className="desc mb-36">
                                    We are more than just a tech company; we are a vibrant ecosystem of thinkers, makers, and doers.
                                    Join us to connect, learn, and grow together.
                                </p>
                                <div className="btn-part">
                                    <Link className="readon2" to="/contact-us">
                                        Join Our Community
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-img" data-aos="fade-left" data-aos-duration="1200">
                                <img
                                    src={heroImg}
                                    alt="Community"
                                    style={{
                                        borderRadius: '20px',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 2. Visual Gallery / Moments */}
            <div className="rs-gallery pt-100 pb-100 bg8">
                <div className="container">
                    <div className="sec-title text-center mb-50">
                        <h2 className="title">Community Moments</h2>
                        <div className="desc">
                            Snapshots of passion, collaboration, and fun.
                        </div>
                    </div>

                    <div className="row">
                        {/* Large Item */}
                        <div className="col-lg-8 col-md-12 mb-30">
                            <div className="gallery-item" style={{
                                position: 'relative',
                                borderRadius: '15px',
                                overflow: 'hidden',
                                height: '400px'
                            }}>
                                <img src={gallery2} alt="Teamwork" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                <div className="overlay" style={{
                                    position: 'absolute',
                                    bottom: 0, left: 0, right: 0,
                                    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                                    padding: '30px',
                                    color: '#fff'
                                }}>
                                    <h3 style={{ color: '#fff', fontSize: '24px' }}>Collaboration</h3>
                                </div>
                            </div>
                        </div>

                        {/* Small Item 1 */}
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="gallery-item" style={{
                                position: 'relative',
                                borderRadius: '15px',
                                overflow: 'hidden',
                                height: '400px'
                            }}>
                                <img src={gallery1} alt="Fun" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                <div className="overlay" style={{
                                    position: 'absolute',
                                    bottom: 0, left: 0, right: 0,
                                    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                                    padding: '30px',
                                    color: '#fff'
                                }}>
                                    <h3 style={{ color: '#fff', fontSize: '24px' }}>Fun</h3>
                                </div>
                            </div>
                        </div>

                        {/* Small Item 2 */}
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="gallery-item" style={{
                                position: 'relative',
                                borderRadius: '15px',
                                overflow: 'hidden',
                                height: '400px'
                            }}>
                                <img src={gallery3} alt="Energy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                <div className="overlay" style={{
                                    position: 'absolute',
                                    bottom: 0, left: 0, right: 0,
                                    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                                    padding: '30px',
                                    color: '#fff'
                                }}>
                                    <h3 style={{ color: '#fff', fontSize: '24px' }}>Energy</h3>
                                </div>
                            </div>
                        </div>

                        {/* Large Item 2 (Text/CTA) */}
                        <div className="col-lg-8 col-md-12 mb-30">
                            <div className="gallery-item" style={{
                                borderRadius: '15px',
                                height: '400px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: '#202020', // Secondary color
                                padding: '40px',
                                textAlign: 'center'
                            }}
                                data-aos="fade-up"
                                data-aos-duration="1400"
                            >
                                <div>
                                    <h2 style={{ color: '#fff', fontSize: '36px', marginBottom: '20px' }}>Ready to be part of the story?</h2>
                                    <Link className="readon2" to="/contact-us" style={{ background: '#ffc107', color: '#111827' }}>
                                        Join Us Today
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 3. Minimal Features */}
            <div className="rs-services style2 pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="services-item" style={{ padding: '30px', background: '#f9f9f9', borderRadius: '10px', height: '100%' }}>
                                <div className="services-icon mb-20">
                                    <i className="fa fa-users fa-3x" style={{ color: '#ffc107' }}></i>
                                </div>
                                <div className="services-content">
                                    <h3 className="title">Networking</h3>
                                    <p className="desc mb-0">Connect with industry leaders and peers.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="services-item" style={{ padding: '30px', background: '#f9f9f9', borderRadius: '10px', height: '100%' }}>
                                <div className="services-icon mb-20">
                                    <i className="fa fa-lightbulb-o fa-3x" style={{ color: '#ffc107' }}></i>
                                </div>
                                <div className="services-content">
                                    <h3 className="title">Innovation</h3>
                                    <p className="desc mb-0">Share ideas and build the future together.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="services-item" style={{ padding: '30px', background: '#f9f9f9', borderRadius: '10px', height: '100%' }}>
                                <div className="services-icon mb-20">
                                    <i className="fa fa-rocket fa-3x" style={{ color: '#ffc107' }}></i>
                                </div>
                                <div className="services-content">
                                    <h3 className="title">Growth</h3>
                                    <p className="desc mb-0">Workshops, mentorship, and career growth.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CommunityMain;
